module.exports = __webpack_public_path__ + "../static/media/snr.ee7d2ef3.jpg";